export enum LANGUAGES {
  ru = 'ru',
  en = 'en',
  es = 'es',
}

export const languageSwitcherItems: Record<LANGUAGES, { text: string }> = {
  ru: { text: 'Русский' },
  en: { text: 'English' },
  es: { text: 'Español' },
};

export const PRIMARY_LANG: LANGUAGES =
  ((window._env_.PRIMARY_LANGUAGE || import.meta.env.PRIMARY_LANGUAGE) as LANGUAGES) || LANGUAGES.en;
export const SECONDARY_LANG: LANGUAGES | undefined = (window._env_.SECONDARY_LANGUAGE ||
  import.meta.env.SECONDARY_LANGUAGE) as LANGUAGES;
